(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-pill"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Overlay: watch drawer state and toggle overlay
  const drawerContainer = document.querySelector('#Details-menu-drawer-container');
  const overlay = document.querySelector('.pill-drawer__overlay');

  if (drawerContainer && overlay) {
    overlay.addEventListener('click', () => {
      drawerContainer.removeAttribute('open');
      drawerContainer.classList.remove('menu-opening');
    });

    new MutationObserver(() => {
      const isOpen = drawerContainer.classList.contains('menu-opening');
      overlay.classList.toggle('is-active', isOpen);
    }).observe(drawerContainer, { attributes: true, attributeFilter: ['class'] });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-steps"] && !Shopify.designMode) return;
  try {
    
class HowItWorksSteps extends HTMLElement {
  connectedCallback() {
    this.stepCount = parseInt(this.dataset.stepCount) || 1;
    this.activeStep = 0;
    this.snapMode = this.dataset.snap === 'true';
    this.stepBtns = Array.from(this.querySelectorAll('[data-step]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.stepBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.goToStep(parseInt(btn.dataset.step), true);
      });
    });

    this._onScroll = this._handleScroll.bind(this);
    this._onResize = () => { this._sectionTop = null; };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });

    if (this.snapMode) {
      this._snapLock = false;
      this._touchStartY = 0;
      this._onWheel = this._handleWheel.bind(this);
      this._onTouchStart = (e) => { this._touchStartY = e.touches[0].clientY; };
      this._onTouchEnd = this._handleTouchEnd.bind(this);
      window.addEventListener('wheel', this._onWheel, { passive: false });
      window.addEventListener('touchstart', this._onTouchStart, { passive: true });
      window.addEventListener('touchend', this._onTouchEnd, { passive: true });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    if (this.snapMode) {
      window.removeEventListener('wheel', this._onWheel);
      window.removeEventListener('touchstart', this._onTouchStart);
      window.removeEventListener('touchend', this._onTouchEnd);
    }
  }

  _isSticky() {
    const rect = this.getBoundingClientRect();
    return rect.top <= 10 && rect.bottom >= window.innerHeight - 10;
  }

  _handleWheel(e) {
    if (!this._isSticky()) { this._wheelAccum = 0; return; }

    const inner = e.target.closest('.how-it-works__panel-inner');
    if (inner) {
      const goingDown = e.deltaY > 0;
      const canScrollDown = inner.scrollTop + inner.clientHeight < inner.scrollHeight - 1;
      const canScrollUp = inner.scrollTop > 0;
      if ((goingDown && canScrollDown) || (!goingDown && canScrollUp)) return;
    }

    e.preventDefault();
    if (this._snapLock) return;

    this._wheelAccum = (this._wheelAccum || 0) + e.deltaY;
    if (Math.abs(this._wheelAccum) < 60) return;

    const dir = this._wheelAccum > 0 ? 1 : -1;
    this._wheelAccum = 0;

    const next = this.activeStep + dir;
    if (next < 0 || next >= this.stepCount) return;

    this._snapLock = true;
    this.goToStep(next, true);
    setTimeout(() => { this._snapLock = false; this._wheelAccum = 0; }, 1000);
  }

  _handleTouchEnd(e) {
    if (!this._isSticky() || this._snapLock) return;
    const delta = this._touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(delta) < 30) return;
    const dir = delta > 0 ? 1 : -1;
    const next = this.activeStep + dir;
    if (next < 0 || next >= this.stepCount) return;
    this._snapLock = true;
    this.goToStep(next, true);
    setTimeout(() => { this._snapLock = false; }, 900);
  }

  _handleScroll() {
    const rect = this.getBoundingClientRect();
    const scrolled = -rect.top;
    const vh = window.innerHeight;

    if (scrolled < -vh || scrolled > vh * this.stepCount) return;

    const step = Math.round(scrolled / vh);
    const clamped = Math.max(0, Math.min(step, this.stepCount - 1));

    if (clamped !== this.activeStep) {
      this.goToStep(clamped, false);
    }
  }

  goToStep(index, scrollTo) {
    this.activeStep = index;

    this.stepBtns.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });

    this.panels.forEach((panel, i) => {
      const active = i === index;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', String(!active));
    });

    if (scrollTo) {
      const rect = this.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      window.scrollTo({ top: sectionTop + index * window.innerHeight, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('how-it-works-steps')) {
  customElements.define('how-it-works-steps', HowItWorksSteps);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-pricing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMembershipPricingToggle(sectionId) {
    var container = document.getElementById('membership-pricing-' + sectionId);
    if (!container) return;

    var toggle = container.querySelector('.membership-pricing__toggle-input');
    if (!toggle) return;

    function updatePrices(isAnnual) {
      var priceEls = container.querySelectorAll('[data-price-monthly]');
      priceEls.forEach(function (el) {
        el.textContent = isAnnual
          ? el.getAttribute('data-price-annual')
          : el.getAttribute('data-price-monthly');
      });
    }

    toggle.addEventListener('change', function () {
      updatePrices(toggle.checked);
    });

    // Initialise with annual (checked by default)
    updatePrices(toggle.checked);
  }

  document.querySelectorAll('.membership-pricing__toggle-input').forEach(function (input) {
    var sectionId = input.getAttribute('data-section');
    if (sectionId) initMembershipPricingToggle(sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
